module.exports = __webpack_public_path__ + "img/735501240.720a176b.jpg";